
import Text from  '../common/Text'
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CodeManagement.css'; // CSS 파일 임포트
import AttachFiles from '../common/AttachFiles';
import FileUpload from '../common/FileUpload';

const CodeManagement = () => {

    const [uploadId, setuploadId] = useState('');

    const handleuploadIdChange = (newuploadId) => {
        setuploadId(newuploadId);
        console.log(uploadId);
    }

    const [codes, setCodes] = useState([]);
    const [newCode, setNewCode] = useState('');
    const [editingCode, setEditingCode] = useState(null);
    const [editingText, setEditingText] = useState('');

    useEffect(() => {
        fetchCodes();
    }, []);

    const fetchCodes = async () => {
        const response = await axios.get('/api/codes'); // 스프링부트 API 호출
        setCodes(response.data);
    };

    const addCode = async () => {
        await axios.post('/api/codes', { text: newCode });
        setNewCode('');
        fetchCodes();
    };

    const updateCode = async (id) => {
        await axios.put(`/api/codes/${id}`, { text: editingText });
        setEditingCode(null);
        setEditingText('');
        fetchCodes();
    };

    const deleteCode = async (id) => {
        await axios.delete(`/api/codes/${id}`);
        fetchCodes();
    };

    return (
        <div className="code-management-container">
            <h1>코드 관리 화면</h1>

            <FileUpload uploadId={uploadId} ValueChange={handleuploadIdChange} />

            <h1>업로드ID : {uploadId}</h1> 
            <AttachFiles uploadId={uploadId} />

            <div className="add-code">
                <input
                    type="text"
                    value={newCode}
                    onChange={(e) => setNewCode(e.target.value)}
                    placeholder="새 코드를 입력하세요"
                />
                <button onClick={addCode}>추가</button>
            </div>
            <ul className="code-list">
                {codes.map(code => (
                    <li key={code.id} className="code-item">
                        {editingCode === code.id ? (
                            <>
                                <input
                                    type="text"
                                    value={editingText}
                                    onChange={(e) => setEditingText(e.target.value)}
                                />
                                <button onClick={() => updateCode(code.id)}>수정</button>
                                <button onClick={() => setEditingCode(null)}>취소</button>
                            </>
                        ) : (
                            <>
                                <span>{code.text}</span>
                                <button onClick={() => { setEditingCode(code.id); setEditingText(code.text); }}>수정</button>
                                <button onClick={() => deleteCode(code.id)}>삭제</button>
                            </>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CodeManagement;